import React from 'react';
import AppContainer from './components/AppContainer';
import DetailPage from './components/DetailPage';
import Overview from './components/Overview';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppContainer />, // This layout is always shown
    children: [
      // These are rendered inside the <Outlet />
      { index: true, element: <Overview /> },
      { path: 'stevens', element: <DetailPage locationName="Stevens Pass" /> },
      { path: 'crystal', element: <DetailPage locationName="Crystal" /> },
      {
        path: 'snoqualmie',
        element: <DetailPage locationName="Snoqualmie Pass" />,
      },
      { path: 'baker', element: <DetailPage locationName="Baker" /> },
      { path: 'paradise', element: <DetailPage locationName="Paradise" /> },
    ],
  },
]);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
